import { useState, createRef } from 'react';
import type { RefObject, MouseEvent } from 'react';

export interface SkipNavContextValue {
  mainContentRef: RefObject<HTMLElement>;
  mainContentFocused: boolean;
  mainContentOnFocus: () => void;
  mainContentOnBlur: () => void;
}

const mainContentRef = createRef<HTMLElement>();

export const skipToMainContent = (event?: MouseEvent): void => {
  if (event) {
    event.preventDefault();
  }
  if (mainContentRef.current) {
    mainContentRef.current.setAttribute('tabindex', '0');
    mainContentRef.current.focus();
  }
};

/**
 * @deprecated use `skipToMainContent` or `<SkipNav.Anchor />` instead.
 */
export const useSkipNav = (): { skipToMainContent: (event?: MouseEvent) => void } => {
  return { skipToMainContent };
};

export const useSkipNavState = (): SkipNavContextValue => {
  const [mainContentFocused, setMainContentFocused] = useState(false);
  const mainContentOnBlur = (): void => {
    setMainContentFocused(false);
    mainContentRef.current?.setAttribute('tabindex', '-1');
  };
  const mainContentOnFocus = (): void => {
    setMainContentFocused(true);
  };
  return { mainContentFocused, mainContentOnFocus, mainContentOnBlur, mainContentRef };
};
